import {
    Box,
    Text,
    VStack,
    HStack,
    Badge,
    Icon,
    Skeleton,
    SkeletonCircle,
    SkeletonText
  } from "@chakra-ui/react";
  import { FaHourglassEnd } from "react-icons/fa";
  //import timeAgo from "../../utils/timeAgo";
  import dateUtils from "../../utils/formatDate";
  import { useTranslation } from "react-i18next";
  
  const ExpiredPointHistory = ({ expiredPointsTransactions, isLoading, bgColor, textColor, iconColor }) => {
    const savedLanguage = localStorage.getItem("i18nextLng") || "en";
    const {t} = useTranslation();

    return (
      <VStack
        width="100%"
        spacing={2}
        borderRadius="xl"
        overflowY="auto"
        maxHeight="400px"
      >
      {isLoading ? (
        // Skeleton Loader
        Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            p={4}
            borderRadius="xl"
            bg={bgColor}
            color={textColor}
            borderBottomWidth={2}
            width="100%"
          >
            {/* Main Row - Icon + Details + Points */}
            <HStack justify="space-between" align="center">
              {/* Skeleton for Icon & Text */}
              <HStack spacing={4} align="center">
                <SkeletonCircle boxSize="6" />
                <Skeleton height="4" width="120px" />
              </HStack>
    
              {/* Skeleton for Points Section */}
              <HStack spacing={1} flex={2} justify="flex-end">
                <Skeleton height="8" width="40px" />
                <Skeleton height="6" width="50px" />
              </HStack>
            </HStack>
    
            {/* Skeleton for Expired Date Text */}
            <SkeletonText noOfLines={1} spacing="2" skeletonHeight="3" mt={2} />
          </Box>
        ))
      ) : expiredPointsTransactions?.length > 0 ? (
        expiredPointsTransactions
        .sort((a, b) => new Date(b.expiration_date) - new Date(a.expiration_date)) // 🔁 sort latest first
        .filter((transaction) => transaction.type === "expired" && transaction.points !== 0)
        .map((transaction) => (
          <Box
            key={transaction.transaction_id}
            p={4}
            borderRadius="xl"
            bg={bgColor}
            color={textColor}
            borderBottomWidth={2}
            width="100%"
          >
            {/* Main Row - Icon + Details + Points */}
            <HStack justify="space-between" align="center">
              <HStack spacing={4} align="center">
                <Icon as={FaHourglassEnd} color={iconColor} boxSize={5} />
                <Text fontSize="xs" fontWeight="bold">
                  {transaction?.expiration_date
                    ? dateUtils.formatDate(transaction?.expiration_date, savedLanguage)
                    : t('expired')}
                </Text>
              </HStack>

              {/* Points Section */}
              <HStack spacing={1} flex={2} justify="flex-end">
                <Text color={iconColor} fontSize="xl" fontWeight="bold">
                  {dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}
                </Text>
                <Badge color={iconColor} px={2} py={1} borderRadius="md">
                  {t('point')}
                </Badge>
              </HStack>
            </HStack>

            {/* Expired points datetime ago */}
            <Text fontSize="xs" color="gray.500" fontWeight="bold" mt={1}>
              {transaction?.expiration_date &&
                dateUtils.timeAgo(new Date(transaction.expiration_date), savedLanguage)}
            </Text>
          </Box>
        ))

        // expiredPointsTransactions
        //   .filter((transaction) => transaction.type === "expired" && transaction.points !== 0)
        //   .map((transaction) => (
        //     <Box
        //       key={transaction.transaction_id}
        //       p={4}
        //       borderRadius="xl"
        //       bg={bgColor}
        //       color={textColor}
        //       borderBottomWidth={2}
        //       width="100%"
        //     >
        //       {/* Main Row - Icon + Details + Points */}
        //       <HStack justify="space-between" align="center">
        //         <HStack spacing={4} align="center">
        //           <Icon as={FaHourglassEnd} color={iconColor} boxSize={5} />
        //           <Text fontSize="xs" fontWeight="bold">
        //             {transaction?.expiration_date
        //               ? dateUtils.formatDate(transaction?.expiration_date, savedLanguage)
        //                 : t('expired')
        //             }
        //           </Text>
        //         </HStack>
    
        //         {/* Points Section */}
        //         <HStack spacing={1} flex={2} justify="flex-end">
        //           <Text color={iconColor} fontSize="xl" fontWeight="bold">
        //             {dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}
        //           </Text>
        //           <Badge color={iconColor} px={2} py={1} borderRadius="md">
        //             {t('point')}
        //           </Badge>
        //         </HStack>
        //       </HStack>
    
        //       {/* Expired points datetime ago */}
        //       <Text fontSize="xs" color="gray.500" fontWeight="bold" mt={1}>
        //         {transaction?.expiration_date && dateUtils.timeAgo(new Date(transaction.expiration_date), savedLanguage)}
        //       </Text>
        //     </Box>
        //   ))
      ) : null }
    </VStack>
    
    );
  };
  
  export default ExpiredPointHistory;
  